// Maps division name → brand-book accent color
export const DIVISION_COLOR = {
  Studio: "#FF5600",      // Blaze Orange
  Marketing: "#7100D0",   // Royal Violet
  Experience: "#FF001D",  // Racing Red
};

export const divisionColor = (division) => DIVISION_COLOR[division] || "#0C14E4";
